import { useIsItemAvailable } from 'src/modules/checkout/composables/sales-availability/items/IsItemAvailable'
import { computed, toValue } from 'vue'

// Options is a hash containing fields that can be used to validate item availability.
const DEFAULT_OPTIONS = Object.freeze({
  salesChannel: null,
  order: null
})

// items and options are optional, assuming the caller may intend to use computeAvailableItems directly
export function useAvailableItems (items = [], options = DEFAULT_OPTIONS) {
  const { isItemAvailable } = useIsItemAvailable()

  function computeAvailableItems (items, { salesChannel, order } = DEFAULT_OPTIONS) {
    return _(toValue(items))
      .filter(item => isItemAvailable(item, { salesChannel, order }))
      .sortBy('displayOrder')
      .value()
  }

  // We wrap items with computed to ensure reactivity
  // useAvailableItems may be called with a null model, which wouldn't be reactive
  // e.g. props?.category?.items?.data before category is set
  // This would prevent availableItems from reacting to changes in items
  // If items is set or already reactive, this is a safe no-op
  // This ensures useAvailableItems is resilient without complicated usage requirements
  const availableItems = computed(() => computeAvailableItems(computed(() => items), options))

  return {
    computeAvailableItems,
    availableItems
  }
}
